import { Control, Controller } from 'react-hook-form';
import CronInput from '../inputs/CronInput';

interface FormControlInputProps {
  name: string;
  control: Control<any>;
}

const FormCronInput = ({ name, control }: FormControlInputProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <CronInput
        value={field.value}
        onChange={field.onChange}
        error={fieldState.error?.message}
      />
    )}
  />
);

export default FormCronInput;
